// window.apiBaseUrl = 'http://v2-manager-api.local/api/';
window.apiBaseUrl = 'http://35.156.118.226/api/';
// window.frontendUrl = 'http://localhost:8080';
window.frontendUrl = 'https://unruffled-cori-aad365.netlify.com';
window.loginServiceUrl = 'http://v-dev.local';
window.Event = new Vue();

require('@/assets/css/main.css');

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { i18n } from './i18n.js'

Vue.config.productionTip = false
Vue.use(i18n);

Vue.prototype.$label = function (label) {

    if (window.templateLabels.hasOwnProperty(label)) {
        return window.templateLabels[label];
    }

    return label;
}

Vue.prototype.$partnerEndpoint = function (path) {
    return 'partners/' + localStorage.partnerCode + '/' + path;
}

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
